module.exports = __webpack_public_path__ + "img/jk.50a0a8ac.jpg";